module.exports = __webpack_public_path__ + "static/media/tampa_team.09620385.jpg";